import type { ContentPage } from "@/lib/content/types";

export const approvalProcess: ContentPage = {
  slug: "process-management/approval-process",
  template: "hrmsFeature",
  seo: {
    title: "Approval Process Software - Automate Sales Approvals | GetBiz CRM",
    description:
      "Automate multi-level approvals for discounts, deals and quotes with GetBiz CRM. Route requests to the right approver instantly and keep deals moving.",
    keywords: [
      "approval process software",
      "sales approval workflow",
      "discount approval",
      "deal approval automation",
      "CRM approvals",
      "multi-level approval",
    ],
    ogImage: "/assets/data/seoimages/approval-process.webp",
  },
  leaf: {
    hero: {
      caption: "Approval Process",
      title: "Automate Approvals So Deals Never Wait",
      description:
        "Route discounts, quotes and deals to the right approver automatically, with multi-level rules and instant notifications — so nothing stalls waiting for a sign-off.",
      h1: "caption",
    },
    split: {
      title: "Fast, Consistent Approvals",
      bullets: [
        { title: "Multi-level Rules", description: "Chain approvers by amount, stage or team." },
        { title: "Instant Routing", description: "Requests reach the right person in seconds." },
        { title: "Notifications", description: "Approvers are alerted and can act in one click." },
        { title: "Full Audit Trail", description: "Every approval is logged for compliance." },
      ],
      image: "/assets/images/img/product/crm/approvals-image.webp",
      imageAlt: "GetBiz CRM approval process",
    },
    cardsHeading: {
      title: "More Process Management Tools",
      description: "Approval Process works with the rest of GetBiz CRM process management.",
    },
    cards: [
      { title: "Sales Blueprint", href: "/crm-software/process-management/sales-blueprint/", description: "Embed approvals inside your guided sales process.", image: "/assets/images/img/product/crm/sales-blueprint.webp", imageAlt: "CRM sales blueprint" },
      { title: "Assignment Rule", href: "/crm-software/process-management/assignment-rule/", description: "Assign records to the right owner and approver.", image: "/assets/images/img/product/crm/assignment-rule.webp", imageAlt: "CRM assignment rule" },
      { title: "Review Process", href: "/crm-software/process-management/review-process/", description: "Add review checkpoints before approvals.", image: "/assets/images/img/product/crm/review-process.webp", imageAlt: "CRM review process" },
      { title: "Validation Rule", href: "/crm-software/process-management/validation-rule/", description: "Ensure records are complete before approval.", image: "/assets/images/img/product/crm/validation-rule.webp", imageAlt: "CRM validation rule" },
    ],
    testimonials: { title: "Keep deals moving", description: "See why teams automate approvals in GetBiz CRM." },
    bookDemoTitle: "Automate your approvals today.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "sales-approval-workflow-guide, deal-approval-process-guide",
    metaKey: "approval-process",
  },
  sections: [],
};
